var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.row[_vm.col.value])?_c('span',[_vm._m(0)]):_c('span',[_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"icon icon-checkmark"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"icon icon-x"})])
}]

export { render, staticRenderFns }